import { getAmplifyToken } from "./AmplifyHelp";
import { ErrorObject } from "./generalHelp";


/**
 * function that takes invoiceBody and passes it on to backend to either add or update an invoice
 * @param {object} invoiceBody object representing invoice to be added or edited
 * @param {responseHandler} callback callback function to return response to 
 * @category Api Calls
 * @subcategory Invoices
 * @module
 */
export function putInvoice(invoiceBody, callback){
    getAmplifyToken((jwt) => {
    fetch(`${process.env.REACT_APP_TIMESHEET_API}/con/invoice/add`,{
        method:'PUT',
        headers: { "Content-Type": "application/json", "Authorization": jwt },
        body: JSON.stringify(invoiceBody)
    }).then(resp => callback(resp)).catch(err => {console.error(err); callback(false)})
    })
    
}
/**
 * downloads an invoice document from s3 that has the name filename
 * @param {String} filename name of file to be downloaded
 * @param {responseHandler} callback function where the response is passed to
 */
export function getInvoiceDocumentUrl(filename, callback){
    getAmplifyToken((jwt)=>{
        fetch(`${process.env.REACT_APP_TIMESHEET_API}/con/s3/presigned?filename=${filename}`,
        {headers:{Authorization:jwt}}).then(resp => resp.json()).then(data => callback(data.url))
        .catch(err => {console.error(err); callback(undefined)})
    })
}

/**
 * api call used to reset a timesheet to a new status
 * @param {object} jsonObj object that contains the id of the timesheet with changing status, status to change to, and admin that is changing it 
 * @param {responseHandler} callback 
 */
export function putTimesheet(jsonObj, callback){
    getAmplifyToken((jwt) => {
    fetch(`${process.env.REACT_APP_TIMESHEET_API}/con/timesheet/reset`,{
        method:'POST',
        headers: { "Content-Type": "application/json", "Authorization": jwt },
        body: JSON.stringify(jsonObj)
    }).then(resp => callback(resp.ok)).catch(err => {console.error(err); callback(false)})
    })   
}

export function weekUnlockTimesheet(jsonObj, callback){
    getAmplifyToken((jwt) => {
        fetch(`${process.env.REACT_APP_TIMESHEET_API}/con/timesheet/week_reset`,{
            method:'POST',
            headers: { "Content-Type": "application/json", "Authorization": jwt },
            body: JSON.stringify(jsonObj)
        }).then(resp => callback(resp.ok)).catch(err => {console.error(err); callback(false)})
    })  
}


export function setTimesheetStatus(resource_id, project_id, ref_date, status, callback){
    getAmplifyToken((jwt) => {
        fetch(`${process.env.REACT_APP_TIMESHEET_API}/con/timesheet/week_reset`,{
            method:'POST',
            headers: { "Content-Type": "application/json", "Authorization": jwt },
            body: JSON.stringify({
                resource_id: resource_id,
                project_id: project_id,
                ref_date, ref_date,
                status: status
            })
        }).then(resp => callback(resp.ok)).catch(err => {console.error(err); callback(false)})
        })   
}

export function setTimesheetInvoice(invoiceObj, callback){
    getAmplifyToken((jwt)=>{
        fetch(`${process.env.REACT_APP_TIMESHEET_API}/con/invoice/addweek`,{
            method: 'PUT',
            headers: { "Content-Type": "application/json", "Authorization": jwt },
            body: JSON.stringify(invoiceObj)
        }).then(async resp => resp.ok ? resp : new ErrorObject(resp.status, await resp.text()))
        .then(resp => callback(resp))
        .catch((err) => {console.error(err); return new ErrorObject(500, "could not add invoice, please try again.")})
    })
}


/**
 * Function that posts the invoice rate for a project detail. The assumption for the invoice body object is as follows:
 * @param {JSON} invoiceBody : {invoice_effective_date, billing_frequency, billing_type, fixed_amount (optional), po_number}
 */
export function postInvoiceRate(invoiceBody, callback){
    getAmplifyToken((jwt) => {
    fetch(`${process.env.REACT_APP_CONTRACTS_API}/con/invoice/invoice_rate`,{
        method:'POST',
        headers: { "Content-Type": "application/json", "Authorization": jwt },
        body: JSON.stringify(invoiceBody)
    }).then(resp => callback(resp)).catch(err => {console.error(err); callback(false)})
    })
    
}

/**
 * Function that gets all unconfirmed invoices, pending to be either approved or rejected.
 * @param {function} callback : Callback function
 */
export function getAllUnconfirmedInvoices(callback){
    getAmplifyToken((jwt) => {
    fetch(`${process.env.REACT_APP_CONTRACTS_API}/con/invoice/unconfirmed_invoices`,{
        method: 'GET',
        headers: {"Authorization": jwt }
    }).then(resp => resp.json()).then(json => callback(json)).catch(err => {console.error(err); callback(false)})
    })
    
}


/**
 * Function that confirms an unconfirmed invoice, given an id for the invoice to be confirmed.
 * @param {function} callback : Callback function
 * @param {int} id : ID of the pending invoice on the backend to be confirmed
 */
export function confirmInvoice(id, callback){
    getAmplifyToken((jwt) => {
    fetch(`${process.env.REACT_APP_CONTRACTS_API}/con/invoice/confirm_invoice`,{
        method: 'POST',
        headers: {"Content-Type": "application/json", "Authorization": jwt },
        body: JSON.stringify({"id": id})
    }).then(resp => resp.json()).then(json => callback(json)).catch(err => {console.error(err); callback(false)})
    })
    
}


/**
 * Function that confirms an unconfirmed invoice, given an id for the invoice to be rejected.
 * @param {function} callback : Callback function
 * @param {int} id : ID of the pending invoice on the backend to be rejected
 */
export function rejectInvoice(id, callback){
    getAmplifyToken((jwt) => {
    fetch(`${process.env.REACT_APP_CONTRACTS_API}/con/invoice/reject_invoice`,{
        method: 'POST',
        headers: {"Content-Type": "application/json", "Authorization": jwt },
        body: JSON.stringify({"id": id})
    }).then(resp => resp.json()).then(json => callback(json)).catch(err => {console.error(err); callback(false)})
    })
    
}


/**
 * Function that edits an unconfirmed invoice
 * @param {function} callback : Callback function
 * @param {JSON} invoice : Invoice to update on the backend
 */
export function editInvoice(invoice, callback){
    getAmplifyToken((jwt) => {
    fetch(`${process.env.REACT_APP_CONTRACTS_API}/con/invoice/edit_invoice`,{
        method: 'PATCH',
        headers: {"Content-Type": "application/json", "Authorization": jwt },
        body: JSON.stringify({"invoice": invoice})
    }).then(resp => resp.json()).then(json => callback(json)).catch(err => {console.error(err); callback(false)})
    })
    
}


/**
 * Function that deletes the invoice rate for a project detail. The assumption for the invoice body object is as follows:
 * @param {JSON} invoiceBody : {'id': ID of the invoice rate to delete on the backend}
 */
export function deleteInvoiceRate(invoiceBody, callback){
    getAmplifyToken((jwt) => {
    fetch(`${process.env.REACT_APP_CONTRACTS_API}/con/invoice/invoice_rate`,{
        method:'DELETE',
        headers: { "Content-Type": "application/json", "Authorization": jwt },
        body: JSON.stringify(invoiceBody)
    }).then(resp => callback(resp)).catch(err => {console.error(err); callback(false)})
    })
    
}